import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchLeaveHierarchyCount = createAsyncThunk(
  "leaveHierarchyCount/fetchLeaveHierarchyCount",
  async (filters = {}, { getState, rejectWithValue }) => {
    try {
      const { accessToken } = getState().auth;

      const { 
        companyId, 
        branchId, 
        leaveTypeId, 
        status
      } = filters;

      const params = {};

      if (branchId && branchId !== 'All') params.branchId = branchId;
      if (leaveTypeId && leaveTypeId !== 'All') params.leaveTypeId = leaveTypeId;
      if (status && status !== "All") params.status = status;

      let url = `${API_URL}/leave/company/${companyId}/hierarchy/count`;

      console.log(
        `📡 Fetching Leave Hierarchy Count URL: ${url} with params:`,
        JSON.stringify(params)
      );

      const response = await axios.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      console.log("Leave Hierarchy Count Response Data:", response.data);
      return response.data;
    } catch (err) {
      console.log(err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch leave hierarchy count";
      return rejectWithValue(errorMessage);
    }
  },
);

const leaveHierarchyCountSlice = createSlice({
  name: "leaveHierarchyCount",
  initialState: {
    count: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    clearLeaveHierarchyCountError: (state) => {
      state.error = null;
    },
    resetLeaveHierarchyCount: (state) => {
      state.count = 0;
      state.status = "idle";
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaveHierarchyCount.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLeaveHierarchyCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.count = typeof action.payload === 'object' && action.payload !== null ? action.payload.count : action.payload;
      })
      .addCase(fetchLeaveHierarchyCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearLeaveHierarchyCountError, resetLeaveHierarchyCount } = leaveHierarchyCountSlice.actions;

export default leaveHierarchyCountSlice.reducer;